import {Button, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import dashboard from "../../assets/img/dashboard.png";
import React, {useState} from "react";
import "./WithSubscribe.css"
import {useTranslation} from "react-i18next";
import hostname from "../../hostname";

const WithSubscribe = () => {
    const {t} = useTranslation();

    const [formDisabled, setFormDisabled] = useState(true);
    const [validated, setValidated] = useState(null);
    const [formState, setFormState] = useState('initial');

    function onFormSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        const formData = new FormData(event.target);
        const email = formData.get("email");

        if (formDisabled) {
            setValidated(false)
            return;
        }


        if (!email.trim()) {
            setValidated(false)
            alert('Please enter your email address.');
            return;
        }

        setValidated(true);
        setFormState('loading');


        fetch(
            hostname + '/index.php/collect',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-us-app-id': 'rhesus'
                },
                body: JSON.stringify({email: email.trim()}),
            }
        )
            .then(response => {
                if (!response.ok) {
                    console.warn('Server returned an error:', response.status);
                    setFormState('error');
                    return;
                }
                setFormState('success');
                resetForm();
            })
            .catch(error => {
                console.error('Error during API call:', error);
                setFormState('error');
                resetForm();
            });
    }

    function resetForm() {
        setTimeout(
            () => {
                setFormState('initial')
            },
            5000
        )
    }


    return (
        <Container fluid className="min-vh-100 d-flex flex-column overflow-hidden ps-3 pe-3 mt-3">
            <Row className={"align-items-center text-center text-lg-start min-vh-100"}>
                <Col lg={"6"} className={"px-lg-5"}>
                    <h1 className={"display-4 fw-bold text-uppercase"}
                        dangerouslySetInnerHTML={{__html: t("pages.home.hero.withSubscribe.title")}}>
                    </h1>
                    <p className={"mt-4"}>
                        {t("pages.home.hero.withSubscribe.subTitle")}
                    </p>
                    <Form className={"d-flex gap-2 mt-4 flex-column"} validated={validated} onSubmit={onFormSubmit}>
                        <InputGroup size="lg">
                            <Form.Control
                                aria-label="Large"
                                type={"email"}
                                placeholder={t("pages.home.hero.withSubscribe.form.input.placeholder")}
                                aria-describedby="inputGroup-sizing-sm"
                                name={"email"}
                                disabled={formDisabled}
                            />
                        </InputGroup>
                        <InputGroup className={"align-self-stretch input-group d-flex flex-grow-1 flex-column"}>
                            <Button type="submit" className={"text-white"}
                                    disabled={formDisabled}>{t("pages.home.hero.withSubscribe.form.button.text")}</Button>
                        </InputGroup>
                        <Form.Group className="mb-3">
                            <Form.Check
                                required
                                label={t("pages.home.hero.withSubscribe.form.checkBox.consent")}
                                onClick={() => setFormDisabled(!formDisabled)}
                                feedback={t("pages.home.hero.withSubscribe.form.checkBox.feedback")}
                                feedbackType={"invalid"}
                            />
                            <div className={"mt-2"}>
                                <small className={formState === 'success' ? "text-success" : "text-success d-none"}
                                       id="green">{t("pages.home.hero.withSubscribe.form.success")}</small>
                                <small className={formState === 'error' ? "text-danger" : "text-danger d-none"}
                                       id="red">{t("pages.home.hero.withSubscribe.form.error")}</small>
                            </div>
                        </Form.Group>
                    </Form>
                </Col>
                <Col lg={"6"} className={"text-center"}>
                    <img src={dashboard} alt="dashboard" className={"img-fluid rounded shadow"}/>
                </Col>
            </Row>
        </Container>
    )
}

export default WithSubscribe;
